/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Sync_Already_In_ProgressInputs */



/**
* | output |
* | --- |
* | "A sync is already in progress for this space." |
*
* @param {Spaces_Sync_Already_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_sync_already_in_progress = /** @type {((inputs?: Spaces_Sync_Already_In_ProgressInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Sync_Already_In_ProgressInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Synchronisierung läuft bereits für diesen Space.")
	return /** @type {LocalizedString} */ ("A sync is already in progress for this space.")
});